import { Component, inject } from '@angular/core'

import { ButtonComponent, TypographyComponent } from '@hyperkit'

import { HuntPackageService as HuntPackageAPIService } from '../../../../../../../modules/shared/services'
import {
  TrackingEventEnum,
  TrackingService,
} from '../../../../../../../tracking/tracking.service'
import { PackageViewService } from '../../../../../services/reader/package-view.service'
@Component({
  standalone: true,
  selector: 'query-selected-emulation-validation-tab',
  imports: [TypographyComponent, ButtonComponent],
  templateUrl: './emulation-validation-tab.component.html',
  styleUrls: ['./emulation-validation-tab.component.scss'],
})
export class EmulationValidationTabComponent {
  public readonly pkgView = inject(PackageViewService)
  private readonly pkgAPI = inject(HuntPackageAPIService)
  public readonly trackingService = inject(TrackingService)

  /** The array of validation file names/types */
  readonly validationTypes = this.pkgView.validationTypes

  /** Map of validation file name → content/string */
  readonly validation = this.pkgView.validation

  /** Download a single validation artifact by its filename */
  downloadValidation(filename: string): void {
    this.trackingService.trackEvent(
      TrackingEventEnum.RESEARCH_EMULATION_VALIDATION_DOWNLOADED,
      {
        UUID: this.pkgView.UUID,
        title: this.pkgView.title,
      },
    )
    const pkg = this.pkgView.activePackage()
    if (!pkg?.UUID) return
    this.pkgAPI.downloadHuntPackageValidation(pkg.UUID, filename)
  }
}
